<template>
  <v-app>
    <v-main class="main-bg">

      <!-- HERO / BANNER -->
      <Header :event-details="event"/>
      <v-container class="mt-2">
        <v-row class="d-flex align-center justify-center">
          <v-col cols="12" sm="12" md="12" lg="4" class="text-center">
            <h1>Let's Start Your Journey</h1>
          </v-col>
          <v-col cols="12" sm="12" md="12" lg="8">
            <div class="stepper-wrapper">
              <div class="step">
                <div class="circle">
                  <v-icon color="white">mdi-badge-account</v-icon>
                </div>
                <span>Basic Info</span>
              </div>

              <div class="line"></div>

              <div class="step">
                <div class="circle">
                  <v-icon color="white">mdi-calendar-edit</v-icon>
                </div>
                <span>Event Details</span>
              </div>

              <div class="line"></div>

              <div class="step">
                <div class="circle">
                  <v-icon color="white">mdi-view-list</v-icon>
                </div>
                <span>Preferences</span>
              </div>

            </div>
          </v-col>
        </v-row>
      </v-container>
      <!-- STEP FORM -->
      <section class="form-section" ref="registrationSection">
        <v-container>
          <v-row class="mt-10 pb-1" align="stretch">
            <!-- LEFT FORM -->
            <v-col cols="12" md="6">
              <v-card class="pa-5 form-card fill-height" rounded="xl" elevation="2">
                <v-card-text>
                  <div class="section-title mb-6">
                    <v-icon color="brown darken-2">
                      mdi-account-outline
                    </v-icon>

                    Basic Information
                  </div>
                  <v-text-field outlined dense label="Full Name *" color="brown" v-model="details.name"></v-text-field>
                  <v-text-field outlined dense label="Partner / Companion Name" color="brown"
                    v-model="details.partner_name"></v-text-field>
                  <v-text-field outlined dense label="Email Address *" color="brown"
                    v-model="details.email"></v-text-field>
                  <v-row no-gutters>
                    <v-col cols="12" md="6" class="pr-md-2">
                      <v-text-field outlined dense label="Mobile Number *" color="brown"
                        v-model="details.mobile"></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6" class="pl-md-2">
                      <v-text-field outlined dense label="City / Province *" color="brown"
                        v-model="details.city"></v-text-field>
                    </v-col>
                  </v-row>
                  <v-text-field outlined dense label="Facebook/Instagram (Optional)" color="brown"
                    v-model="details.socialMedia"></v-text-field>
                </v-card-text>
              </v-card>
            </v-col>

            <!-- RIGHT CATEGORY -->
            <v-col cols="12" md="6">
              <v-card class="pa-5 form-card" rounded="xl" elevation="2">
                <v-card-text>
                  <div class="section-title mb-6">
                    <v-icon color="brown darken-2">
                      mdi-shape-outline
                    </v-icon>
                    Registration Category
                  </div>

                  <v-radio-group v-model="details.category">
                    <v-row no-gutters>
                      <v-col cols="12" sm="6">
                        <v-radio label="Wedding" value="1" color="brown darken-2"></v-radio>
                        <v-radio label="Travel" value="2" color="brown darken-2"></v-radio>
                        <v-radio label="Celebration" value="3" color="brown darken-2"></v-radio>
                      </v-col>
                    </v-row>
                  </v-radio-group>

                  <div class="mt-5">
                    <div class="dynamic-title mb-4">
                      Who are you registering as?
                    </div>

                    <v-radio-group v-model="details.registering_as">
                      <v-row no-gutters>
                        <v-col cols="12" sm="6">
                          <v-radio label="Couple" value="Couple" color="brown darken-2"></v-radio>
                          <v-radio label="Bride/Groom-to-be" value="Bride/Groom-to-be" color="brown darken-2"></v-radio>
                          <v-radio label="Celebrant" value="Celebrant" color="brown darken-2"></v-radio>
                          <v-radio label="Corporate Representative" value="Corporate Representative"
                            color="brown darken-2"></v-radio>
                        </v-col>
                        <v-col cols="12" sm="6">
                          <v-radio label="Event Planner" value="Event Planner" color="brown darken-2"></v-radio>
                          <v-radio label="Family Organizer" value="Family Organizer" color="brown darken-2"></v-radio>
                          <v-radio label="Travel Enthusiast" value="Travel Enthusiast" color="brown darken-2"></v-radio>
                          <v-radio label="Other" value="Other" color="brown darken-2"></v-radio>
                        </v-col>
                      </v-row>
                    </v-radio-group>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <v-row class="mt-5 pb-1" align="stretch" v-if="details.category">
            <!-- LEFT FORM -->
            <v-col cols="12" md="6">
              <v-card class="pa-5 form-card fill-height" rounded="xl" elevation="2">
                <v-card-text>
                  <div class="section-title mb-6">
                    <v-icon color="brown darken-2">
                      {{ eventCategoryOptions.icon }}
                    </v-icon>
                    {{ eventCategoryOptions.name }} Details
                  </div>
                  <v-select outlined dense 
                      v-model="details.date"
                      label="Target Date*" 
                      item-key="value" 
                      item-text="text" 
                      :items="targetDateItems">
                  </v-select>
                  <template v-if="eventCategoryOptions.type == 'wedding'">
                    <v-select outlined dense label="Wedding Type*" color="brown" :items="eventTypes"
                      v-model="details.event.type">
                    </v-select>
                    <v-select outlined dense label="Estimated Travel Budget*" color="brown" :items="budgetRanges"
                      v-model="details.event.budget">
                    </v-select>
                    <v-text-field outlined dense label="Estimated Number of Guests*" color="brown"
                      v-model="details.event.guests">
                    </v-text-field>
                  </template>
                  <template v-if="eventCategoryOptions.type == 'travel'">
                    <v-text-field outlined dense label="Enter Country or Destination*" color="brown"
                      v-model="details.event.country">
                    </v-text-field>
                    <v-select outlined dense label="Select Travel Interest*" color="brown" :items="travelInterests"
                      v-model="details.event.type">
                    </v-select>
                    <v-select outlined dense label="Estimated Travel Budget*" color="brown" :items="budgetRanges"
                      v-model="details.event.budget">
                    </v-select>
                  </template>
                  <template v-if="eventCategoryOptions.type == 'celebration'">
                    <v-select outlined dense label="Celebration / Event Type*" color="brown" :items="celebrationTypes"
                      v-model="details.event.type">
                    </v-select>
                    <v-select outlined dense label="Estimated Travel Budget*" color="brown" :items="budgetRanges"
                      v-model="details.event.budget">
                    </v-select>
                  </template>
                  <div class="dynamic-title mb-4">
                    {{ eventCategoryOptions.name }} Services Needed *
                  </div>
                  <v-row no-gutters>
                    <v-col>
                      <v-checkbox :label="op.label" v-for="op in eventCategoryOptions.options.column1" :key="op.value"
                        v-model="details.event.needs" :value="op.value" color="brown darken-2" hide-details
                        dense></v-checkbox>
                    </v-col>
                    <v-col>
                      <v-checkbox :label="option.label" v-for="option in eventCategoryOptions.options.column2"
                        :key="option.value" v-model="details.event.needs" :value="option.value" color="brown darken-2"
                        hide-details dense></v-checkbox>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-textarea :label="eventCategoryOptions.remarks" color="brown" v-model="details.event.remarks"
                        outlined dense></v-textarea>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>

            <!-- RIGHT CATEGORY -->
            <v-col cols="12" md="6">
              <v-card class="pa-5 form-card" rounded="xl" elevation="2">
                <v-card-text>
                  <div class="section-title mb-6">
                    <v-icon color="brown darken-2">
                      mdi-heart
                    </v-icon>
                    Preferences & Interests
                  </div>

                  <div class="dynamic-title mb-4">
                    What is your biggest challenge in planning *
                  </div>
                  <v-radio-group v-model="details.biggest_challenge">
                    <v-row no-gutters>
                      <v-col cols="12" sm="6">
                        <v-radio label="Budgeting" value="Budgeting" color="brown darken-2"></v-radio>
                        <v-radio label="Finding Trusted Suppliers" value="Finding Trusted Suppliers"
                          color="brown darken-2"></v-radio>
                        <v-radio label="Venue Selection" value="Venue Selection" color="brown darken-2"></v-radio>
                        <v-radio label="Travel Planning" value="Travel Planning" color="brown darken-2"></v-radio>
                        <v-radio label="Time Management" value="Time Management" color="brown darken-2"></v-radio>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <v-radio label="Styling and Theme" value="Styling and Theme" color="brown darken-2"></v-radio>
                        <v-radio label="Coordination" value="Coordination" color="brown darken-2"></v-radio>
                        <v-radio label="Guest Management" value="Guest Management" color="brown darken-2"></v-radio>
                      </v-col>
                    </v-row>
                  </v-radio-group>

                  <div class="mt-5">
                    <div class="dynamic-title mb-4">
                      How did you hear about us?
                    </div>

                    <v-radio-group v-model="details.source">
                      <v-row no-gutters>
                        <v-col>
                          <v-radio label="Facebook" value="Facebook" color="brown darken-2"></v-radio>
                          <v-radio label="Instagram" value="Instagram" color="brown darken-2"></v-radio>
                          <v-radio label="Tiktok" value="Tiktok" color="brown darken-2"></v-radio>
                          <v-radio label="Friend/Referral" value="Friend/Referral" color="brown darken-2"></v-radio>
                        </v-col>
                        <v-col>
                          <v-radio label="Website" value="Website" color="brown darken-2"></v-radio>
                          <v-radio label="Exhibitor" value="Exhibitor" color="brown darken-2"></v-radio>
                          <v-radio label="Advertisement" value="Advertisement" color="brown darken-2"></v-radio>
                          <v-radio label="Other" value="Other" color="brown darken-2"></v-radio>
                        </v-col>
                      </v-row>
                    </v-radio-group>
                  </div>
                </v-card-text>
              </v-card>
              <v-card rounded="xl" class="mt-5 pa-5">
                <v-card-text>
                  <div class="section-title mb-6">
                    <v-icon color="brown darken-2">
                      mdi-shield-outline
                    </v-icon>
                    Consent
                  </div>
                  <div>
                    <label class="text-md">
                      I agree to receive updates, promotions, and offers from participating exhibitors and organizers.
                    </label>
                    <v-checkbox v-model="details.receive_updates" label="Yes, I agree" color="brown darken-2" hide-details dense />
                  </div>
                  <div class="mt-5">
                    <label class="text-md">
                      I agree to the event's Privacy Policy and Data Collection Terms.
                    </label>
                    <v-checkbox v-model="details.agreed" label="Yes, I agree" color="brown darken-2" hide-details dense />
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <!-- SUBMIT -->
          <div class="text-center mt-10">
            <v-btn x-large rounded color="brown darken-3" class="white--text px-12" @click="submit()" :loading="loading">
              Continue Registration
            </v-btn>
          </div>

        </v-container>

      </section>
      <Footer />
    </v-main>
    <v-dialog v-model="errorsDialog" max-width="500">
      <v-card>
        <v-card-title class="text-h5">Please fix the following errors:</v-card-title>
        <v-list dense>
          <v-list-item v-for="(item, i) in errors" :key="i">
            <v-list-item-content>
              {{ item[0] }}
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="errorsDialog = false">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="successDialog" max-width="300">
      <v-card>
        <v-card-text class="text-center pa-4">
          <h3>Registration Successful!</h3>
        </v-card-text>
        <v-card-text class="text-center">
          <v-icon color="green" class="text-xxl mb-2">mdi-check-circle</v-icon>
          <p>Please check your email for the generated QR Code.</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="success" @click="successDialog = false" outlined block>OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import api from '@/services/axios';
import { utilsMixin } from '@/composables/utils';
import Header from '../components/Header.vue';
import Footer from '../components/Footer.vue';
export default {
  name: "PassportJourneyLanding",
  mixins: [utilsMixin],
  components : {Header, Footer},
  data() {
    return {
      loading : false,
      modal: false,
      events: [],
      event : {},
      errorsDialog: false,
      successDialog: false,
      errors: [],
      currentStep: 1,
      eventCategoryOptions: {},
      form: {
        basicInfo: false,
        eventDetails: false,
        consent: false,
      },
      details: {
        category: null,
        biggest_challenge: "Budgeting",
        registering_as: null,
        source: 'Other',
        event: {
          date: null,
          needs: [],
        }
      }
    };
  },
  watch: {
    details: {
      handler(newVal) {
        //Validate Basic Info
        this.form.basicInfo = this.validBasicInfo(newVal);
        //Validate Event Details
        if (newVal.category == 1) { //Wedding
          this.form.eventDetails = this.validWeddingEventDetails(newVal.event);
        }

        this.eventCategoryOptions = this.getCategoryOptions(newVal.category);

      },
      deep: true
    }
  },
  async mounted() {
      try {
          let response = await api.get(process.env.VUE_APP_API_URL + '/active-events');

          this.activeEvents = response.data;
          if (this.activeEvents.length > 0) {
              this.event = this.activeEvents[0];
              console.log(this.event)
          }
      } catch (error) {
          console.log(error);
      }
  },
  methods: {
    validBasicInfo(details) {
      return details.fullName && details.email && details.mobileNumber && details.city;
    },
    validWeddingEventDetails(event) {
      return event.date && event.type && event.budget && event.guests && event.needs.length > 0;
    },
    goToRegistrationPage() {
      this.$refs.registrationSection.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    },
    setEventStyle(style) {
      this.details.style = style;
      this.$forceUpdate(); // Force re-render to update active state of theme icons
    },
    submit() {
      this.loading = true;
      this.details.category_type = this.eventCategoryDetails[this.details.category]?.type;
      this.details.event_id = this.event.id;
      api.post('/event-registration', this.details)
        .then(response => {
          this.successDialog = true;
          this.details = {
            category: null,
            biggest_challenge: "Budgeting",
            registering_as: null,
            source: 'Other',
            event: {
              date: null,
              needs: [],
            }
          };

          fbq('track', 'Lead', {
            content_name: 'PTIDO Attendee Registration',
            content_category: 'Event Registration',
            registration_type: 'attendee'
          });

        })
        .catch(error => {
          console.error('Error submitting registration:', error);
          this.errors = error.response.data.errors;
          this.errorsDialog = true;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
};
</script>

<style scoped>
.main-bg {
  background: #f8f5f1;
}


/* PASSPORT CARD */
.passport-card {
  position: relative;
}

.passport-img {
  width: 420px;
  border-radius: 28px;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.25);
}

.floating-badge {
  position: absolute;
  bottom: -20px;
  right: -20px;

  background: #5d4037;
  color: white;

  padding: 14px 20px;
  border-radius: 40px;

  display: flex;
  align-items: center;
  gap: 10px;

  font-weight: 600;
}

/* FORM */
.form-section {
  margin-top: -40px;
  position: relative;
  z-index: 5;
  padding-bottom: 80px;
}

.form-card {
  border-radius: 24px;
  background: white;
}

.section-title {
  display: flex;
  align-items: center;
  gap: 10px;

  font-size: 22px;
  font-weight: 700;
  color: #4e342e;
}

.dynamic-title {
  font-size: 18px;
  font-weight: 700;
  color: #5d4037;
}

/* STEPPER */
.stepper-wrapper {
  padding: 24px 30px;
  border-radius: 24px;

  display: flex;
  align-items: center;
  justify-content: center;


  flex-wrap: wrap;
}

.step {
  display: flex;
  flex-direction: column;
  align-items: center;

  min-width: 100px;
}

.circle {
  width: 42px;
  height: 42px;
  border-radius: 50%;

  background: #d7ccc8;
  color: #5d4037;

  display: flex;
  align-items: center;
  justify-content: center;

  font-weight: bold;
  margin-bottom: 8px;
}

.step.active .circle {
  background: #5d4037;
  color: white;
}

.step span {
  font-size: 13px;
  color: #6d4c41;
  font-weight: 600;
}

.line {
  width: 70px;
  height: 2px;
  background: #d7ccc8;
  margin: 0 10px;
}

.v-stepper {
  background: transparent !important;
  box-shadow: none !important;
}

.v-stepper__content {
  padding: 0 !important;
}

.text-md {
  font-size: 16px;
}

/* MOBILE */
@media (max-width: 960px) {
  .hero-title {
    font-size: 42px;
  }

  .passport-img {
    width: 100%;
    margin-top: 40px;
  }

  .line {
    display: none;
  }

  .stepper-wrapper {
    gap: 20px;
  }
}

@media (max-width: 768px) {
  .hero-section {
    background-image:
      linear-gradient(rgba(255, 255, 255, 0.78),
        rgba(255, 255, 255, 0.75)),
      url("@/assets/passport-banner/banner2.png");
    /* background-image: url("@/assets/passport-banner/banner-mobile.png"); */
    background-size: cover;
    background-position: left center;
  }


  .stepper-wrapper {
    gap: 0px;
  }
}

.theme-icon {
  border-radius: 5px;
  padding: 5px 10px;
  border: 1px solid #5d4037;
  cursor: pointer;
}

.theme-icon.active {
  background: #5d4037;
  color: white;
  border-color: #5d4037;
}

.text-sm {
  font-size: 14px;
}


.font-facifico {
  font-family: 'Pacifico', cursive;
}

.font-dm-serif {
  font-family: 'DM Serif Display', serif;
}

.text-xxl {
  font-size: 5rem !important;
}

.text-gold {
  color: #685519;
}
</style>